import { render, staticRenderFns } from "./AnswerInfo.vue?vue&type=template&id=bbf8dd74&scoped=true&"
import script from "./AnswerInfo.vue?vue&type=script&lang=js&"
export * from "./AnswerInfo.vue?vue&type=script&lang=js&"
import style0 from "./AnswerInfo.vue?vue&type=style&index=0&id=bbf8dd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf8dd74",
  null
  
)

export default component.exports